import PropTypes from "prop-types";
import React from "react";

const GiveFeedbackIcon = props => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5983 2.97899C18.7643 2.78899 19.1321 2.74998 19.3869 3.00513L20.0613 3.68059C20.3014 3.92103 20.3014 4.25656 20.0613 4.49701L19.5144 5.04474L18.0259 3.554L18.5739 3.00513C18.5823 2.99669 18.5905 2.98798 18.5983 2.97899ZM17.2662 4.31474L18.7548 5.80549L11.6468 12.9241L10.1583 11.4333L17.2662 4.31474ZM9.15976 10.9118L16.7425 3.3178C16.7687 3.25518 16.8074 3.19652 16.8584 3.14557C16.9091 3.09501 16.9672 3.05666 17.0294 3.0305L17.8018 2.25686C18.4249 1.56164 19.5076 1.60458 20.1476 2.24552L20.822 2.92097C21.4812 3.58112 21.4812 4.59647 20.822 5.25662L11.4923 14.6003C11.4333 14.6594 11.3613 14.7039 11.2821 14.7304L8.41571 15.6872C8.40265 15.6916 8.38942 15.6955 8.37606 15.6988C8.1088 15.7657 7.80753 15.7089 7.59058 15.5134C7.47806 15.4119 7.38666 15.2697 7.35371 15.0949C7.32362 14.9351 7.34813 14.7795 7.40744 14.6424L8.35373 11.7993C8.38007 11.7201 8.42445 11.6482 8.48338 11.5892L8.8769 11.1951C8.90314 11.1335 8.94139 11.0759 8.99164 11.0257C9.04151 10.9759 9.09871 10.9379 9.15976 10.9118ZM9.39865 12.194L10.8872 13.6848L10.8212 13.7508L8.5892 14.496L9.33371 12.2591L9.39865 12.194ZM6.56402 22.1556C7.66974 21.7206 7.42748 20.5212 6.8684 19.7631C6.31554 18.9863 5.55148 18.4519 4.7812 17.9361C4.2316 17.5895 3.74088 17.1574 3.32761 16.6559C3.31651 16.6428 3.30467 16.629 3.29234 16.6147C3.11139 16.4037 2.82259 16.067 3.15988 15.9972C3.45303 15.9376 3.91705 16.1562 4.25635 16.3161C4.34126 16.3561 4.41837 16.3924 4.48303 16.4198C4.85393 16.5747 5.22216 16.7457 5.57895 16.9363C5.88647 17.1005 6.27528 17.0065 6.4533 16.7067C6.6231 16.4208 6.53939 16.0503 6.25141 15.884C5.37617 15.3787 4.35274 14.9625 3.38973 14.8227C2.73126 14.7233 2.03553 14.86 1.8119 15.5746C1.61312 16.1898 1.92992 16.8113 2.29022 17.296C2.7829 17.9544 3.43382 18.4149 4.08627 18.8765C4.56082 19.2122 5.03619 19.5485 5.45209 19.962L5.46995 19.9793C5.67747 20.1806 5.92146 20.4174 6.04222 20.6952C6.17267 20.9687 6.14161 20.9873 5.84965 20.9873C5.27504 20.9873 4.59327 20.6519 4.02353 20.3164C3.72728 20.1419 3.34403 20.2311 3.16847 20.5267C2.99831 20.8132 3.08833 21.1851 3.37749 21.3508C4.32334 21.8926 5.59333 22.4776 6.56402 22.1556Z"
        fill={props.fill}
      />
    </svg>
  );
};

GiveFeedbackIcon.defaultProps = {
  height: 24,
  width: 24,
};

GiveFeedbackIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default GiveFeedbackIcon;
